import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Message, MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { AlertServiceService } from 'src/app/api-module/services/alertservice/alert-service.service';
import { NotificationsService } from 'src/app/dispatcher/notifications.service';
import { AuthenticationServicesService } from 'src/app/api-module/services/authentication/authentication-services.service';

@Injectable({
  providedIn: 'root'
})
export class SharedNotificationService {

  acceptChangeRankSubject = new Subject<any>();
  notificationCountSubject = new Subject<number>();
  notificationData = new Subject<any>();
  notificationCount: number = 0;
  msgs: Message[] = [];
  constructor(private messageService: MessageService, private router: Router,
    private alertService: AlertServiceService, private authenticationService: AuthenticationServicesService) {

    console.log("this.notificationsService.receiveMessage().subscribe")


    this.notificationData.subscribe(
      (msg: any) => {
        console.log('test', msg)
        if (msg.data.NotificationType == 'RecieveCall') {
          this.msgs = [];
          try {
            let phone = msg.data.phone;
            this.alertService.OnReciveCall.emit(phone);
            // // '96552121214';
            // this.msgs.push({severity:'info', summary:'Info Message',
            // detail:'<a href="http://www.primeng.com/">Visit PrimeNG</a>'});
            // this.notificationCountSubject.next(this.notificationCount);           
            // this.messageService.add({
            //   severity: 'warn',
            //   summary: msg.notification.title,
            //   detail: `<a href="#/customer/customersearch?SearchVal=${phone}" target="_blank">A New Call Is Recieved Click Here To View It </a>`,
            //   //life: 60 * 60 * 1000,
            //   closable: false,
            //   //sticky: true
            // });
          }
          catch (err) {
            console.error('some thing went wrong with dealing with the a push notification ', err);
          }
        }
        else {
          this.notificationCount = this.notificationCount + 1;
          try {
            this.notificationCountSubject.next(this.notificationCount);
            if (msg && msg.notification) {
              this.messageService.add({
                severity: 'success',
                summary: msg.notification.title,
                detail: msg.notification.body,
              });
            }
          }
          catch (err) {
            console.error('some thing went wrong with dealing with the a push notification ', err);
          }
        }
      },
      (err: any) => {
        this.messageService.add({
          severity: 'erroe',
          summary: 'erroe',
          detail: 'erroe',
        })
      }
    )

  }
  // clear() {
  //   this.msgs = [];
  // }
  Redirect() {
    console.log('bbbbb')
    this.router.navigate(['/customer/customersearch']);
  }

  // Called when this browser session receives a push saying the same account logged in elsewhere
  // (Limited Users config). Logs this session out immediately so only one session stays active.
  forceLogout(msg: any) {
    try {
      this.authenticationService.logout();
      localStorage.clear();
      sessionStorage.clear();
      const title = (msg && msg.notification && msg.notification.title) || 'Session Ended';
      const body = (msg && msg.notification && msg.notification.body) || 'Your account was signed in from another device. You have been signed out of this session.';
      this.messageService.add({
        severity: 'warn',
        summary: title,
        detail: body,
        sticky: true
      });
    }
    catch (err) {
      console.error('something went wrong while force-logging out this session ', err);
    }
    finally {
      // A soft router.navigate() can be silently blocked (a route guard, a dirty
      // form's CanDeactivate check) or leave stale authenticated components/state
      // behind. Force a hard reload straight to /login so the whole SPA - navbar,
      // in-memory state, pending requests - is torn down and rebuilt from scratch
      // against the now-cleared storage. Short delay so the toast is readable first.
      setTimeout(() => {
        window.location.href = window.location.pathname + '#/login';
      }, 2000);
    }
  }
}
